import { render, staticRenderFns } from "./NAttributeEditorComponent.vue?vue&type=template&id=12e1ef66&scoped=true"
import script from "./NAttributeEditorComponent.vue?vue&type=script&lang=js"
export * from "./NAttributeEditorComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e1ef66",
  null
  
)

export default component.exports